<template>
    <div>DG
      <AboutSection
        :image1="require('@/assets/AllSystem/pa/image1.png')"
        :image2="require('@/assets/AllSystem/pa/image2.png')"
        :section1="$t('menus.pa.about_us.section1')"
        :section2Title="$t('menus.pa.about_us.section2.title')"
        :section2Content="$t('menus.pa.about_us.section2.content')"
      />
      <ContactMap
        :contactCards="contactCards"
      />
    </div>
  </template>
  <script>  
  import AboutSection from '../share/AboutUs.vue'
  import ContactMap from '../../components/share/ContactPerson.vue'

  export default {
    data(){
      return{
        contactCards: [
          {
            title:this.$t('menus.pa.about_us.administration.title'),
            items: [
              {
                label: this.$t('menus.pa.about_us.administration.fullname'),
                // icon: "fa-solid fa-chevron-right",
                // value: "Kabineti i Kryeprokurorit të Shtetit"
              },
              {
                label: "Email",
                icon: "fa-solid fa-envelope",
                value: this.$t('menus.pa.about_us.administration.email'),
              },
              {
                label: "Tel/Fix",
                icon: "fa-solid fa-phone-volume",
                value: this.$t('menus.pa.about_us.administration.tel'),
              },
              {
                label: "Adresa",
                icon: "fa-solid fa-location-dot",
                value:
                this.$t('menus.pa.about_us.administration.address'),
              }
            ]
          }
        ]
      }
    },
    components: {
      AboutSection,
      ContactMap
    },
  };
  </script>
  
  <style scoped>
  .textBox:first-child{
    border-right:4px solid #F5BD2A;
    padding-right:10px;
  }
  .textBox:nth-child(2){
    border-left:4px solid #F5BD2A;
    padding-left:10px;
  }
  </style>